<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >  
    <el-row :gutter="16" class="filter__container"> 

      <!-- Name -->
      <el-col :lg="6" :md="16" :sm="24">
        <el-form-item :prop="fields.name.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.name.label}}</span>
            <el-button v-if="model.name" type="text" @click="resetFieldFilter({ fieldKey: 'name'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.name.label"
            v-model="model[fields.name.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- Sport -->
      <el-col :lg="6" :md="16" :sm="24">
        <el-form-item :prop="fields.sport.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.sport.label}}</span>
            <el-button v-if="model.sport" type="text" @click="resetFieldFilter({ fieldKey: 'sport'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-select
            :placeholder="fields.sport.label"
            v-model="model[fields.sport.name]"
            @change="doFilter"
          >
            <el-option :value="undefined">--</el-option>
            <i class="icon-training" slot="prefix"></i>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.sport.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Type -->
      <el-col :lg="6" :md="16" :sm="24">
        <el-form-item :prop="fields.type.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.type.label}}</span>
            <el-button v-if="model.type" type="text" @click="resetFieldFilter({ fieldKey: 'type'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-select
            :placeholder="fields.type.label"
            v-model="model[fields.type.name]"
            @change="doFilter"
          >
            <el-option :value="undefined">--</el-option>
            <i class="icon-cup" slot="prefix"></i>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.type.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Access -->
      <el-col :lg="5" :md="16" :sm="24">
        <el-form-item :prop="fields.access.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.access.label}}</span>
            <el-button v-if="model.access" type="text" @click="resetFieldFilter({ fieldKey: 'access'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-select
            :placeholder="fields.access.label"
            v-model="model[fields.access.name]"
            @change="doFilter"
          >
            <el-option :value="undefined">--</el-option>
            <i class="icon-lock" slot="prefix"></i>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.access.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Filter buttons -->
      <el-col :lg="1" :md="16" :sm="24">
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            @click="doResetFilter"
            icon="icon-undo"
            circle
          />
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { PropertyModel } from '@modules/property/property-model';
import _ from 'lodash';


const { fields } = PropertyModel;

const filterSchema = new FilterSchema([
  fields.id,
  fields.name,
  fields.sport,
  fields.type,
  fields.access
]);

export default {
  name: 'app-property-list-filter',

  data() {
    return {
      rules: filterSchema.rules(),
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'property/list/loading',
      filter: 'property/list/filter',
    }),

    fields() {
      return fields;
    },
  },

  async mounted() {
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );
    //return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'property/list/doReset',
      doFetch: 'property/list/doFetch',
    }),

    async doResetFilter() {
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });

    },
  },
};
</script>

<style scoped>
</style>